import React, { useState, useEffect } from "react";
import PaymentMethodModal from "./PaymentMethodModal.js";
import FixedMovementModal from "./FixedMovementModal.js";

function Settings(props) {
    const [showModal, setShowModal] = useState(false);
    const [metodoSelezionato, setMetodoSelezionato] = useState(null);

    const [movimentiFissi, setMovimentiFissi] = useState([]);
    const [showFixedModal, setShowFixedModal] = useState(false);

    const caricaMovimentiFissi = async () => {
        try {
            //const risposta = await fetch(`http://localhost:5001/api/movimenti-fissi?codice_fiscale=${props.codiceFiscale}`);
            const risposta = await fetch(`/api/movimenti-fissi?codice_fiscale=${props.codiceFiscale}`);
            const risultato = await risposta.json();
            if (risposta.ok && risultato.success) {
                // Ordiniamo i movimenti fissi per giorno del mese in ordine crescente
                const ordinati = risultato.movimenti_fissi.sort((a, b) => a.giorno_mese - b.giorno_mese);
                setMovimentiFissi(ordinati);
            }
        } catch (errore) {
            console.error("Errore caricamento movimenti fissi:", errore);
        }
    };

    useEffect(() => {
        caricaMovimentiFissi();
    }, []);

    const gestisciSalvataggioFisso = async (datiFissi) => {
        try {
            //const risposta = await fetch('http://localhost:5001/api/aggiungi-movimento-fisso', {
            const risposta = await fetch('/api/aggiungi-movimento-fisso', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...datiFissi,
                    codice_fiscale: props.codiceFiscale
                })
            });
            const risultato = await risposta.json();
            if (risposta.ok && risultato.success) {
                alert("Movimento fisso aggiunto con successo!");
                setShowFixedModal(false);
                caricaMovimentiFissi();
            } else {
                alert(risultato.message || "Errore durante il salvataggio.");
            }
        } catch (errore) {
            console.error("Errore:", errore);
            alert("Impossibile contattare il server.");
        }
    };

    const eliminaMovimentoFisso = async (id) => {
        if (!window.confirm("Vuoi eliminare questo movimento fisso?")) return;
        try {
            //const risposta = await fetch(`http://localhost:5001/api/elimina-movimento-fisso/${id}`, { method: 'DELETE' });
            const risposta = await fetch(`http://localhost:5001/api/elimina-movimento-fisso/${id}`, { method: 'DELETE' });
            const risultato = await risposta.json();
            if (risposta.ok && risultato.success) {
                caricaMovimentiFissi();
            }
        } catch (errore) {
            console.error("Errore eliminazione:", errore);
        }
    };

    const apriAggiungi = () => { setMetodoSelezionato(null); setShowModal(true); };
    const apriModifica = (metodo) => { setMetodoSelezionato(metodo); setShowModal(true); };
    const chiudiModal = () => { setShowModal(false); setMetodoSelezionato(null); };

    const gestisciSalvataggio = async (datiMetodo) => {
        //const endpoint = datiMetodo.id ? 'http://localhost:5001/api/modifica-metodo-pagamento' : 'http://localhost:5001/api/aggiungi-metodo-pagamento';
        const endpoint = datiMetodo.id ? '/api/modifica-metodo-pagamento' : '/api/aggiungi-metodo-pagamento';
        try {
            const risposta = await fetch(endpoint, {
                method: datiMetodo.id ? 'PUT' : 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: datiMetodo.id, codice_fiscale: props.codiceFiscale, nome: datiMetodo.nome, conto: datiMetodo.conto })
            });
            const risultato = await risposta.json();
            if (risposta.ok && risultato.success) {
                chiudiModal();
                if (props.onAggiornaMetodi) props.onAggiornaMetodi();
            }
        } catch (e) { console.error(e); }
    };

    // Calcolo dei totali fissi (Entrate, Uscite e Totale Netto mensile)
    const totaleEntrateFisse = movimentiFissi
        .filter(mf => mf.eu)
        .reduce((acc, mf) => acc + Number(mf.importo), 0);

    const totaleUsciteFisse = movimentiFissi
        .filter(mf => !mf.eu)
        .reduce((acc, mf) => acc + Number(mf.importo), 0);

    const bilancioFissoNetto = totaleEntrateFisse - totaleUsciteFisse;

    return (
        <div style={styles.container}>
            <h2>Impostazioni</h2>
            <p style={styles.subtitle}>Gestisci il tuo account, i metodi e le ricorrenze</p>

            {/* SEZIONE METODI DI PAGAMENTO */}
            <div style={styles.section}>
                <div style={styles.sectionHeader}>
                    <h3>I tuoi Metodi di Pagamento</h3>
                    <button onClick={apriAggiungi} style={styles.addBtn}>+ Aggiungi</button>
                </div>
                {props.metodiPagamento && props.metodiPagamento.length > 0 ? (
                    <ul style={styles.list}>
                        {props.metodiPagamento.map((metodo) => (
                            <li key={metodo.id} onClick={() => apriModifica(metodo)} style={styles.listItem}>
                                <span><strong>{metodo.nome}</strong> {metodo.conto ? `(${metodo.conto})` : ''}</span>
                                <span style={styles.editHint}>Modifica ✏️</span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p style={{ color: '#94a3b8' }}>Nessun metodo registrato.</p>
                )}
            </div>

            {/* SEZIONE MOVIMENTI FISSI / RICORRENTI */}
            <div style={styles.section}>
                <div style={styles.sectionHeader}>
                    <h3>Movimenti Fissi / Ricorrenti</h3>
                    <button onClick={() => setShowFixedModal(true)} style={styles.addBtn}>+ Aggiungi</button>
                </div>

                {movimentiFissi.length > 0 ? (
                    <>
                        <ul style={styles.list}>
                            {movimentiFissi.map((mf) => (
                                <li key={mf.id} style={styles.listItem}>
                                    <div style={{ textAlign: 'left' }}>
                                        <strong>{mf.soggetto}</strong>
                                        <span style={{ display: 'block', fontSize: '0.8rem', color: '#94a3b8' }}>
                                            Ogni mese il giorno {mf.giorno_mese} • {mf.nome_metodo || 'Conto non specificato'}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <span style={{ fontWeight: 'bold', color: mf.eu ? '#22c55e' : '#ef4444' }}>
                                            {mf.eu ? '+' : '-'} € {Number(mf.importo).toFixed(2)}
                                        </span>
                                        <button onClick={(e) => { e.stopPropagation(); eliminaMovimentoFisso(mf.id); }} style={styles.deleteSmallBtn}>🗑️</button>
                                    </div>
                                </li>
                            ))}
                        </ul>

                        {/* RIGA DI RIEPILOGO TOTALI FISSI */}
                        <div style={styles.summaryBox}>
                            <div style={styles.summaryRow}>
                                <span style={{ color: '#94a3b8' }}>Totale Entrate Fisse:</span>
                                <span style={{ color: '#22c55e', fontWeight: 'bold' }}>+ € {totaleEntrateFisse.toFixed(2)}</span>
                            </div>
                            <div style={styles.summaryRow}>
                                <span style={{ color: '#94a3b8' }}>Totale Uscite Fisse:</span>
                                <span style={{ color: '#ef4444', fontWeight: 'bold' }}>- € {totaleUsciteFisse.toFixed(2)}</span>
                            </div>
                            <div style={{ ...styles.summaryRow, borderTop: '1px solid #334155', paddingTop: '8px', marginTop: '6px' }}>
                                <span style={{ fontWeight: 'bold' }}>Bilancio Fisso Mensile:</span>
                                <span style={{ fontWeight: 'bold', color: bilancioFissoNetto >= 0 ? '#22c55e' : '#ef4444' }}>
                                    {bilancioFissoNetto >= 0 ? '+' : ''} € {bilancioFissoNetto.toFixed(2)}
                                </span>
                            </div>
                        </div>
                    </>
                ) : (
                    <p style={{ color: '#94a3b8', fontSize: '0.9rem' }}>Nessun movimento fisso impostato.</p>
                )}
            </div>

            {/* SEZIONE ACCOUNT / LOGOUT */}
            <div style={styles.section}>
                <h3>Account</h3>
                <button onClick={props.onLogout} style={styles.logoutBtn}>🚪 Esci dall'account (Logout)</button>
            </div>

            {showModal && (
                <PaymentMethodModal 
                    metodoDaModificare={metodoSelezionato}
                    onClose={chiudiModal}
                    onSave={gestisciSalvataggio}
                    onDelete={() => {}}
                />
            )}

            {showFixedModal && (
                <FixedMovementModal 
                    metodiPagamento={props.metodiPagamento}
                    onClose={() => setShowFixedModal(false)}
                    onSave={gestisciSalvataggioFisso}
                />
            )}
        </div>
    );
}

const styles = {
    container: { width: '100%', maxWidth: '500px', margin: '0 auto', padding: '20px', color: '#ffffff', textAlign: 'left' },
    subtitle: { color: '#94a3b8', fontSize: '0.9rem', marginBottom: '20px' },
    section: { backgroundColor: '#1e293b', padding: '20px', borderRadius: '12px', border: '1px solid #334155', marginBottom: '20px' },
    sectionHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' },
    addBtn: { backgroundColor: '#3b82f6', color: '#ffffff', border: 'none', padding: '6px 12px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.85rem' },
    list: { listStyle: 'none', padding: 0, marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' },
    listItem: { backgroundColor: '#0f172a', padding: '12px 15px', borderRadius: '8px', border: '1px solid #334155', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    editHint: { fontSize: '0.8rem', color: '#3b82f6', cursor: 'pointer' },
    deleteSmallBtn: { background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '0.9rem' },
    summaryBox: { marginTop: '15px', backgroundColor: '#0f172a', padding: '12px 15px', borderRadius: '8px', border: '1px solid #334155', display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '0.9rem' },
    summaryRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    logoutBtn: { width: '100%', backgroundColor: '#ef4444', color: '#ffffff', border: 'none', padding: '12px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', fontSize: '1rem' }
};

export default Settings;